import { useEffect } from 'react';
const META_THEME_SELECTOR = 'meta[name="theme-color"]';
const LIGHT_THEME = 'light';
const DARK_THEME = 'dark';
export const useMetaThemeColor = ({
  opened,
  overlayColor,
  colorMixer,
  enabled
}) => {
  useEffect(() => {
    if (!enabled) return;
    const metas = Array.from(document.querySelectorAll(META_THEME_SELECTOR));
    if (!metas.length) return;
    const prevThemeColors = metas.map(meta => meta.getAttribute('content'));
    if (opened) {
      var _document$documentEle;
      const tuiTheme = (_document$documentEle = document.documentElement) == null ? void 0 : _document$documentEle.getAttribute('data-tui-theme');
      const userTheme = window.matchMedia != null && window.matchMedia('(prefers-color-scheme: dark)').matches ? DARK_THEME : LIGHT_THEME;
      const theme = tuiTheme || userTheme;
      metas.forEach((meta, i) => {
        const media = meta.getAttribute('media');
        // Обновляем только тег без медии или с медией совпадающей с пользовательской темой
        if (!media || media.match(userTheme)) {
          meta.setAttribute('content', colorMixer({
            theme,
            overlayColor,
            metaColor: prevThemeColors[i],
            metaMedia: media
          }));
        }
      });
    }
    return () => {
      prevThemeColors.forEach((prevThemeColor, index) => {
        if (prevThemeColor) {
          metas[index].setAttribute('content', prevThemeColor);
        } else {
          metas[index].removeAttribute('content');
        }
      });
    };
  }, [opened, overlayColor, colorMixer, enabled]);
};